// Lucide icon: file-text (https://lucide.dev/icons/file-text)
import { FileText } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconOrder = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <FileText />
    </IconComponentStyled>
  )
}
